import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  cancelButtonName = 'Cancel',
  submitButtonName = 'Submit',
  loading = false,
  isBrandDeletion = false,
}) => {
  const { t: translate } = useTranslation();
  const [secondsRemaining, setSecondsRemaining] = useState(10);

  useEffect(() => {
    setSecondsRemaining(10);
    if (!open || !isBrandDeletion) return undefined;

    const deadline = Date.now() + 10000;
    const timer = setInterval(() => {
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      setSecondsRemaining(remaining);
      if (remaining === 0) clearInterval(timer);
    }, 1000);

    return () => clearInterval(timer);
  }, [open, isBrandDeletion]);

  const isCountdownRunning = isBrandDeletion && secondsRemaining > 0;

  cancelButtonName = cancelButtonName === 'Cancel' ? translate('common.cancel') : cancelButtonName;
  submitButtonName = submitButtonName === 'Submit' ? translate('common.submit') : submitButtonName;
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
        {isBrandDeletion && (
          <DialogContentText sx={{ mt: 2, color: 'error.main', fontWeight: 600 }}>
            {translate('common.brand_deletion_warning', {
              defaultValue: 'Warning: Deleting this brand is permanent. Once deleted, its data cannot be recovered.',
            })}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={() => onClose()}>
          {cancelButtonName}
        </Button>
        {submitButtonName && (
          loading ? (
            <LoadingButton variant="contained" loading={loading} disabled={isCountdownRunning} autoFocus={!isCountdownRunning}>
              {isCountdownRunning ? `${submitButtonName}(${secondsRemaining}s)` : submitButtonName}
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              disabled={isCountdownRunning}
              onClick={() => {
                if (!isCountdownRunning) onConfirm();
              }}
              autoFocus={!isCountdownRunning}
            >
              {isCountdownRunning ? `${submitButtonName}(${secondsRemaining}s)` : submitButtonName}
            </Button>
          )
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
